import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
    selector: 'command-item',
    template: require('./command-item.component.html'),
    styles: [require('./command-item.component.scss')]
})
export class CommandItemComponent {
    @Output() public onSelected = new EventEmitter<string>();
    @Input() public item: string;

    public setSpace() {
        return this.item.replace(/([A-Z]+)/g, ' $1').replace('To', 'to').replace('By', 'by');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/automation/command-item/command-item.component.ts